import React from "react";
import PropTypes from "prop-types";
import axios from "axios/index";
import lodash from "lodash";
import moment from "moment";
import Markdown from 'react-remarkable'

import DateTr from "../table-componets/DateTr.js";
import SubmittedByTr from "../table-componets/SubmittedByTr.js";

const handlerDelete = id => {
  if (window.confirm("Are you sure you wish to delete this form?")) {
    axios.delete(`/completed_forms/${id}.json`).then(() => {
      toastr.error("Form deleted");

      setTimeout(() => {
        window.location.href = "/completed_forms";
      }, 300);
    });
  }
};

const Field = ({ customFieldAnswer }) => {
  var display_value = customFieldAnswer.display_value;

  if (customFieldAnswer.field_type === 2 && customFieldAnswer.display_value) {
    display_value = customFieldAnswer.display_value == "null" ? "" : moment(customFieldAnswer.display_value).format("M/D/YYYY");
  } else if (customFieldAnswer.field_type === "time" && customFieldAnswer.display_value) {
    display_value = customFieldAnswer.display_value == "null" ? "" : moment(customFieldAnswer.display_value, "h:mm:ss").format("h:mm A");
  }

  if (customFieldAnswer.field_type === 12) {
    return (
      <tr>
        <th colSpan={2} className="word-wrap line-break">
          {customFieldAnswer.label}
          <br />
          <Markdown source={display_value} />
        </th>
      </tr>
    );
  }

  if (customFieldAnswer.field_type === 9) {
    return (
      <tr>
        <th className="word-wrap">{customFieldAnswer.label}</th>
        <td className="word-wrap">
          <a className="styled-link" href={`/users/${customFieldAnswer.value}`}>
            {display_value}
          </a>
        </td>
      </tr>
    );
  }

  if (customFieldAnswer.field_type === 10) {
    return (
      <tr>
        <th className="word-wrap">{customFieldAnswer.label}</th>
        <td className="word-wrap"><Markdown source={display_value} /></td>
      </tr>
    );
  }

  return (
    <tr>
      <th className="word-wrap">{customFieldAnswer.label}</th>
      <td className="word-wrap">{display_value}</td>
    </tr>
  );
};

const Attachments = ({ data }) => (
  <tr>
    <th>Attachments</th>
    <td className="word-wrap">
      {data.map(item => (
        <div key={item.id}>
          <a href={item.url} target="_blank" className="styled-link">
            {item.name}
          </a>
        </div>
      ))}
    </td>
  </tr>
);

const ShowResult = ({
  form,
  signatures,
  dataAttachments,
  completed_form_id,
  user,
  locationName,
  customFieldAnswers,
  dataAnswers,
  createdAt,
  allowManage,
}) => (
  <div>
    <h1 className="h1-stacked">{form.title}</h1>
    <center>
      <h2 className="date-h2">{moment(createdAt).format("ddd MMM D, YYYY")}</h2>
    </center>

    <div className="u-form-width-fix">
      {allowManage
        ? [
           <div style={{ textAlign: "right" }}>
            <a
              key="edit"
              href={`/completed_forms/${completed_form_id}/edit`}
              className="btn btn-pink btn-raised btn-long margin-right-five"
            >
              EDIT
            </a>
            <a
              key="pdf"
              href={`/completed_forms/${completed_form_id}.pdf`}
              target="_blank"
              className="btn btn-indigo btn-raised btn-long margin-right-five"
            >
              PDF
            </a>
            <a
              key="delete"
              className="btn btn-grey btn-raised btn-long"
              tabIndex="0"
              onClick={() => handlerDelete(completed_form_id)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handlerDelete(completed_form_id);
                }
              }}
            >
              DELETE
            </a>
          </div>
          ]
        : null}

      <br />
      <br />

      <table className="table table-bordered table-white shadowDepth1">
        <tbody>
          <tr>
            <th style={{ width: "35%" }}>Form ID Number</th>
            <td className="word-wrap">{completed_form_id}</td>
          </tr>
          <tr>
            <th style={{ width: "35%" }}>Location</th>
            <td className="word-wrap">{locationName || "All Locations"}</td>
          </tr>

          {customFieldAnswers.map((customFieldAnswer, index) => (
            <Field key={index} customFieldAnswer={customFieldAnswer} />
          ))}

          {dataAttachments ? <Attachments data={dataAttachments} /> : null}

          {signatures.map((signature, index) => (
            <tr key={index}>
              <th>
                {signature.label} Signature
                <br />
                {moment(signature.date).format("MM/DD/YYYY")}
              </th>
              <td>
                <img src={signature.url} alt="Completed Forms URL" className="img-responsive" style={{maxWidth: '300px', maxHeight: '150px'}} />
              </td>
            </tr>
          ))}

          <SubmittedByTr user={user} alternative={'Public Form Submission'} />

          <DateTr
            fieldName={"Submitted At"}
            fieldValue={createdAt}
            fieldFormat={"M/D/YYYY h:mm A"}
          />
        </tbody>
      </table>
    </div>
  </div>
);

ShowResult.propTypes = {
  form: PropTypes.object,
  signatures: PropTypes.array,
  dataAttachments: PropTypes.array,
  completed_form_id: PropTypes.number,
  user: PropTypes.object,
  locationName: PropTypes.string,
  fields: PropTypes.array,
  dataAnswers: PropTypes.object,
  createdAt: PropTypes.string,
  allowManage: PropTypes.bool,
};

export default ShowResult;
